<template>
  <div class="autocomplete-maps tw-flex lg:tw-flex-row tw-flex-col tw-relative">
    <input type="text" placeholder="Introduce la dirección de tu casa" v-model="direction"/>
    <a class="btn btn-primary tw-self-center" @click="goNextStep">Recibe tu oferta</a>
  </div>
</template>

<script>
import { initiateChips } from "../utils";
import { mapMutations, mapGetters } from "vuex";

export default {
    data: () => ({
        direction: ""
    }),
    computed: {
        ...mapGetters({
            wizard: 'getWizard'
        })
    },
    mounted() {
        initiateChips();
    },
    methods: {
        ...mapMutations(["selectDirection"]),
        goNextStep() {
            if(this.direction){
                this.$cookies.set("directionValue", this.direction, "1d");
                window.location.href = '/simular-inversion/tipo-vivienda';
            }
        },
    },
}
</script>

<style lang="scss">
@import "../../sass/variables";

.autocomplete-maps {
    font-size: 16px;
   
    input {
        background-color: $color-white;
        height: 50px;
        width: 569px;
        border-radius: 25px;
        border: solid 0.5px #818fa6;
        padding: 13px 13px;
        font-family: $font-nimbus !important;

        &:focus-visible {
            outline: 1px solid $primary;
        }
        @media(max-width: $lg){
            width: 100%;
        }
    }
    .btn {
        cursor: pointer;
        @media(min-width: $lg){
            position: absolute;
            right:0;
        }
        @media(max-width: $lg){
            width: 175px;
            margin-top: 1rem;
        }
    }
    .disabled-button-map {
        background-color: $color-grey-hover !important;
        pointer-events: none;
    }
}
</style>